export enum ApiErrorEnum {
  EMAIL_ALREADY_USED = 'BOS_US_008',
  TRIGRAM_ALREADY_USED = 'BOS_US_009',
}
